/**
 * The app no longer uses a service worker. A browser that installed one from an older build would keep
 * serving that build's saved copy on the first visit; remove any such worker and its saved copies as soon
 * as the current app runs, so the next visit always loads the current build.
 */
export default function retireServiceWorker() {
  try {
    if (typeof navigator !== 'undefined' && navigator.serviceWorker?.getRegistrations) {
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.forEach((reg) => reg.unregister()))
        .catch(() => {});
    }
    if (typeof window !== 'undefined' && window.caches?.keys) {
      window.caches
        .keys()
        .then((keys) => keys.forEach((key) => window.caches.delete(key)))
        .catch(() => {});
    }
  } catch (err) {
    // never block the app over cleanup
  }
}
